module.exports = __webpack_public_path__ + "staticcomp/img/cover.05911f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/14/cover.jpg
// module id = yrvW
// module chunks = 39